import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ACTIONTYPES, TableAction } from '../table-ag-grid/models/table-actions-model';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
  selector: 'carm-table-action-buttons',
  templateUrl: './table-action-buttons.component.html',
  styleUrls: ['./table-action-buttons.component.scss'],
})
export class TableActionButtonsComponent implements ICellRendererAngularComp {

  public cell: any;
  params: any;
  public language: string;

  constructor(@Inject(LOCALE_ID) protected localeId: string) {}

  agInit(cellRendererParams: any, ): void {
    this.mapButtonConfig(cellRendererParams);
    this.language = this.localeId;
  }

  private mapButtonConfig(cellRendererParams: any) {
    this.params = cellRendererParams;
    this.params.actions = cellRendererParams.actions.map((action: TableAction) => {
      const buttonLabel = action.buttonText || `ag_grid_component.actions.${action.actionType}`;
      return this.newMethod(action, buttonLabel);
    });
  }

  // eslint-disable-next-line complexity
  private newMethod(action: TableAction, buttonLabel: string) {
    const renderModel: any = action;
    renderModel.label = buttonLabel;
    switch (action.actionType) {
      case ACTIONTYPES.approve:
        renderModel.id = 'approve';
        renderModel.matSuffix = 'check';
        break;
      case ACTIONTYPES.delete:
        renderModel.id = 'delete';
        renderModel.matSuffix = 'close';
        break;
      case ACTIONTYPES.details:
        renderModel.id = 'details';
        renderModel.matSuffix = 'more_horiz';
        break;
      case ACTIONTYPES.edit:
        renderModel.id = 'edit';
        renderModel.matSuffix = 'edit';
        break;
      case ACTIONTYPES.editInvoice:
          renderModel.id = 'editinvoice';
          renderModel.matSuffix = 'editinvoice';
          break;
      case ACTIONTYPES.editVendor:
        renderModel.id = 'editvendor';
        renderModel.matSuffix = 'editvendor';
        break;
      case ACTIONTYPES.add:
        renderModel.id = 'add';
        renderModel.matSuffix = 'add';
        break;
      case ACTIONTYPES.modify:
        renderModel.id = 'modify';
        renderModel.matSuffix = 'edit';
        break;
      case ACTIONTYPES.form:
        renderModel.id = 'form';
        renderModel.matSuffix = 'visibility';
        break;
      case ACTIONTYPES.reject:
        renderModel.id = 'reject';
        renderModel.matSuffix = 'close';
        break;
      case ACTIONTYPES.remove:
        renderModel.id = 'remove';
        renderModel.matSuffix = 'close';
        break;
      case ACTIONTYPES.documents:
        renderModel.id = 'documents';
        renderModel.matSuffix = 'insert_drive_file';
        break;
      case ACTIONTYPES.upload:
        renderModel.id = 'upload';
        renderModel.matSuffix = 'attach_file';
        break;
      case ACTIONTYPES.payment:
        renderModel.id = 'payment';
        renderModel.matSuffix = 'attach_money';
        break;
      case ACTIONTYPES.deposit:
        renderModel.id = 'deposit';
        renderModel.matSuffix = 'attach_money';
        break;
      case ACTIONTYPES.download:
        renderModel.id = 'download';
        renderModel.matSuffix = 'file_download';
        break;
      case ACTIONTYPES.withdraw:
        renderModel.id = 'withdraw';
        renderModel.matSuffix = 'close';
        break;
      case ACTIONTYPES.select:
        renderModel.id = 'select';
        renderModel.matSuffix = '';
        renderModel.type = 'carm-button';
        break;
      case ACTIONTYPES.cancel:
        renderModel.id = 'cancel';
        renderModel.matSuffix = 'cancel';
        break;
      case ACTIONTYPES.appeal:
        renderModel.id = 'appeal';
        renderModel.matSuffix = 'gavel';
        break;
      case ACTIONTYPES.view:
        renderModel.id = 'view';
        renderModel.matSuffix = 'visibility';
        break;
      case ACTIONTYPES.viewInvoice:
        renderModel.id = 'viewInvoice';
        renderModel.matSuffix = 'visibility';
        break;
      case ACTIONTYPES.viewCommodity:
        renderModel.id = 'viewCommodity';
        renderModel.matSuffix = 'visibility';
        break;
      case ACTIONTYPES.letter:
        renderModel.id = 'letter';
        renderModel.matSuffix = 'description';
        break;
      case ACTIONTYPES.comment:
        renderModel.id = 'comment';
        renderModel.matSuffix = 'edit';
        break;
      case ACTIONTYPES.viewComment:
          renderModel.id = 'viewComment';
          renderModel.matSuffix = 'comment';
          break;
      case ACTIONTYPES.addComment:
          renderModel.id = 'addComment';
          renderModel.matSuffix = 'rate_review';
          break;
      case ACTIONTYPES.submit:
        renderModel.id = 'submit';
        renderModel.matSuffix = 'check';
        break;
      case ACTIONTYPES.confirmSubmit:
        renderModel.id = 'submit';
        renderModel.matSuffix = 'check';
        break;
      case ACTIONTYPES.errors:
        renderModel.id = 'errors';
        renderModel.matSuffix = 'error_outline';
        break;
      default:
        break;
    }
    return renderModel;
  }

  public onClick(id: string): void {
    const rowData = this.params.data;
    this.params.clicked({ data: rowData, buttonId: id });
  }

  isButtonVisible(button: TableAction, params: ICellRendererParams): boolean {
    if (button.isVisible) {
      return button.isVisible(params.data);
    }
    if (!(params.data)) {
      return true;
    }
    return !button.showActionFieldKey ||
      (button.showActionFieldKey && button.showActionFieldValues.includes(params.data[button.showActionFieldKey]));
  }

  isButtonEnabled(button: TableAction, params: ICellRendererParams): boolean {
    return button.isActionEnabled ? button.isActionEnabled(params.data) : true;
  }

  isButtonDisabled(button: TableAction, params: ICellRendererParams): boolean {
    return !this.isButtonEnabled(button, params);
  }

  refresh(): boolean {
    return false;
  }

}
